<template>
<div>
    <SidebarTitle class="mt-2" icon="CheckCircleIcon" title="days done" hint="mark the days you performed this routine" />
    <div class="flex justify-center">
      <flat-pickr :key="calendarKey" ref="routine_calendar" :config="configInlineDateTimePicker" v-model="datesRaw" placeholder="Inline Picker" />
    </div>

    <div class="mt-8 mb-1">
      <SidebarTitle title="status" icon="ActivityIcon" :hint="hint" />
    </div>
    <div class="flex justify-center">
      <div>
        <div class="flex justify-center mb-1">
          <vs-switch v-model="active" icon-pack="feather" vs-icon-off="icon-pause" vs-icon-on="icon-play" />
        </div>
      </div>


      <!-- <vue-apex-charts type="radialBar" height="100" width="100" :options="chartOptions" :series="[successLevel]" /> -->
    </div>

  </div>


      <!-- <p><span class="font-bold">breakingPoint:</span> {{breakingPoint}}</p> -->
      <!-- <p><span class="font-bold">watchedDays:</span> {{watchedDays}}</p> -->
      <!-- <p><span class="font-bold">urgency:</span> {{urgency}}</p> -->
      <!-- <p><span class="font-bold">lastConsideredDateDone:</span> {{lastConsideredDateDone}}</p> -->

      <!-- <div> -->


<!--       <p><span class="font-bold">started: </span>{{routine.startedOn | date}}</p>
      <p><span class="font-bold">daysRunning: </span>{{daysRunning}}</p>
      <p><span class="font-bold">maxDistance: </span>{{maxDistance}}</p>
      <p><span class="font-bold">lastDateDoneDistance: </span>{{lastDateDoneDistance}}</p>
      <p><span class="font-bold">Urgency: </span>{{urgency}}</p> -->

      <!-- <h5>Length: {{length}} days</h5> -->

      <!-- <p><span class="font-bold">successLevel: </span>{{successLevel}}</p> -->

      <!-- <p><span class="font-bold">Done days:</span> {{datesDone.length}} days</p> -->
      <!-- <p><span class="font-bold">Done days:</span> {{datesDone}} days</p> -->
      <!-- </div> -->
</template>
<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import VueApexCharts from 'vue-apexcharts'
import { midnight, getDateObject } from '@/helpers/date'

export default {
  components: {
    flatPickr,
    VueApexCharts,
  },
  props: {
    routine: {
      type: Object,
      required: false,
      default: () => {}
    },
  },
  data () {
    return {
      active: true,
      datesRaw: '',
      sidebarActive: false,
      chartOptions: {
        chart: {
          height: 350,
          type: 'radialBar',
          offsetY: -10
        },
        plotOptions: {
          radialBar: {
            hollow: {
              // margin: 75,
              size: '10%'
            },
            // startAngle: -135,
            // endAngle: 135,
            dataLabels: {
              name: {
                fontSize: '12px',
                color: undefined,
                offsetY: 30
              },
              value: {
                show: false,
              }
            }
          }
        },
        // fill: {
        //   type: 'gradient',
        //   gradient: {
        //       shade: 'dark',
        //       shadeIntensity: 0.15,
        //       inverseColors: false,
        //       opacityFrom: 1,
        //       opacityTo: 1,
        //       stops: [0, 50, 65, 91]
        //   },
        // },
        // stroke: {
        //   dashArray: 4
        // },
        labels: ['last 30d'],
      },
      // configdateTimePicker: {
      //   disableMobile: false,
      //   parseDate: (datestr) => midnight(new Date(datestr)),
      //   minDate: midnight(this.routine.startedOn),
      //   maxDate: new Date(),
      //   // disable: [(date) => { return date < this.routine.startedOn }],
      //   altInput: true, // optional
      //   altInputClass: 'hide-me',  // optional
      //   wrap: true,
      //   mode: 'multiple',
      //   locale: { firstDayOfWeek: 1 }
      // },

      addSubTaskSkeleton: null,
      subtasksArray: []
    }
  },
  watch: {
    'routine.datesRaw': {
      immediate: true,
      handler (value) {
        console.log('routine.datesRaw watcher')
        this.datesRaw = value

        process.nextTick(() => {
          this.goToCurrentMonth()
        })
      }
    },
    'datesRaw': {
      immediate: false,
      handler () {
        console.log('datesRaw watcher')
        const routine = this.routine
        const updateFields = { datesRaw: this.datesRaw }
        this.$store.dispatch('UPDATE_ROUTINE', {routine, updateFields })
      }
    },
    'routine': {
      immediate: true,
      handler (routine) {
        this.active = !routine.paused
      }
    },
    'active': {
      immediate: false,
      handler () {
        const routine = this.routine
        const updateFields = { paused: !this.active }
        this.$store.dispatch('UPDATE_ROUTINE', {routine, updateFields })
      }
    },
  },
  computed: {
    hint () {
      return this.active ? 'routine is active' : 'routine is paused'
    },
    calendarKey () {
      return this.$store.getters.todayKey
    },
    configInlineDateTimePicker () {
      return {
        disableMobile: false,
        maxDate: 'today',
        parseDate: (datestr) => getDateObject(datestr),
        // minDate: midnight(this.routine.startedOn.toDate()),
        inline: true,
        altInput: true, // optional
        altInputClass: 'hide-me',  // optional
        // wrap: true,
        mode: 'multiple',
        monthSelectorType: 'static',
        locale: { firstDayOfWeek: 1 }
      }
    },
    successLevel () {
      let lvl = 0

      if (this.routine.frequency_period === 'daily') {
        lvl = 100 * (this.datesDoneCount / this.daysRunning)
      } else if (this.routine.frequency_period === 'month') {
        const potential = this.routine.frequency_count * (this.daysRunning / 30)
        lvl = 100 * (this.datesDoneCount / potential)
      } else {
        lvl = 10
      }

      if (lvl > 100) {
        return 100
      } else {
        return Math.round(lvl)
      }
    },
    daysRunning () {
      return Math.abs(this.datesDiff(this.routine.startedOn, midnight()))
    },
  },
  methods: {
    goToCurrentMonth () {
      this.$refs['routine_calendar'].fp.jumpToDate(new Date(), false)
    },
    datesDiff (a, b) {
      const mls = 1000 * 60 * 60 * 24
      return Math.round((a - b) / mls)
    },
  }
}
</script>
<style>
</style>
